export default {
  SET_JOBS: 'setJobs',
  UPDATE_JOB: 'updateJob',
  ADD_JOB: 'addJob',
  REMOVE_JOB: 'removeJob',
  REMOVE_SUBTASKS_BY_PARENT_JOB_ID: 'removeSubtasksByParentJobId',
  SET_JOB_DEFINITIONS: 'setJobDefinitions',
  ADD_JOB_DEFINITION: 'addJobDefinition',
  UPDATE_JOB_DEFINITION: 'updateJobDefinition',
  REMOVE_JOB_DEFINITION: 'removeJobDefinition',
  SET_FOCUSED_JOB_GROUP: 'setFocusedJobGroup',
  SET_TEMP_DELIVERABLES: 'setTempDeliverables',
  CLEAR_TEMP_DELIVERABLES: 'clearTempDeliverables'
}
